export const CREATE_WISHLIST = 'CREATE_WISHLIST'
export const DELETE_WISHLIST = 'DELETE_WISHLIST'
export const REQUEST_WISHLISTS = 'REQUEST_WISHLISTS'
export const RECEIVE_WISHLISTS = 'RECEIVE_WISHLISTS'
export const SET_WISHLIST_LISTING_ID = 'SET_WISHLIST_LISTING_ID'
export const CREATE_WISHLIST_ITEM = 'CREATE_WISHLIST_ITEM'
export const DELETE_WISHLIST_ITEM = 'DELETE_WISHLIST_ITEM'
export const REQUEST_WISHLIST_ITEMS = 'REQUEST_WISHLIST_ITEMS'
export const RECEIVE_WISHLIST_ITEMS = 'RECEIVE_WISHLIST_ITEMS'
export const INVALIDATE_WISHLIST_ITEMS = 'INVALIDATE_WISHLIST_ITEMS'
export const SET_ERROR_STATE = 'SET_ERROR_STATE'
export const REQUEST_MESSAGES = 'REQUEST_MESSAGES'
export const RECEIVE_MESSAGES = 'RECEIVE_MESSAGES'
export const CREATE_MESSAGE = 'CREATE_MESSAGE'
export const CREATE_CART_ITEM = 'CREATE_CART_ITEM'
export const DELETE_CART_ITEM = 'DELETE_CART_ITEM'
export const REQUEST_CART_ITEMS = 'REQUEST_CART_ITEMS'
export const RECEIVE_CART_ITEMS = 'RECEIVE_CART_ITEMS'
export const INVALIDATE_CART_ITEMS = 'INVALIDATE_CART_ITEMS'
export const SET_SELLER_ID = 'SET_SELLER_ID'
export const REQUEST_SELLER_LISTINGS = 'REQUEST_SELLER_LISTINGS'
export const RECEIVE_SELLER_LISTINGS = 'RECEIVE_SELLER_LISTINGS'
export const BOOST_LISTING = 'BOOST_LISTING'
export const MARK_LISTING_AS_SOLD = 'MARK_LISTING_AS_SOLD'
export const UNMARK_LISTING_AS_SOLD = 'UNMARK_LISTING_AS_SOLD'
export const RESERVE_LISTING = 'RESERVE_LISTING'
export const UNRESERVE_LISTING = 'UNRESERVE_LISTING'
export const CANCEL_LISTING = 'CANCEL_LISTING'
export const RELIST_LISTING = 'RELIST_LISTING'
export const UNMARK_LISTING_AS_STALE = 'UNMARK_LISTING_AS_STALE'
export const CHECK_RELISTED_LISTING = 'CHECK_RELISTED_LISTING'
